<template>
    <Shell :transition="transition">
        <template #header>
            <div>
                <button class="flex items-center space-x-1 text-sm hover:underline" @click="voltar()">
                    <svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                        <path
                            fill-rule="evenodd"
                            d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    <span>{{ __('Voltar') }}</span>
                </button>
            </div>
        </template>

        <div class="p-4 space-y-4 flex-grow overflow-auto">
            <div class="bg-white rounded shadow space-y-2 py-2">
                <div class="px-2">
                    <div class="bg-gray-200 flex items-center rounded overflow-hidden">
                        <input v-model="search" class="w-full block px-2 bg-gray-200" />
                        <div class="p-2 flex-shrink-0 flex items-center">
                            <svg
                                class="w-4 h-4 text-gray-600"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </div>
                    </div>
                </div>

                <div v-if="questions === null">
                    {{ __('Carregando...') }}
                </div>

                <div v-else-if="questions.length == 0">
                    {{ __('Nenhum conhecimento encontrado') }}
                </div>

                <div v-else class="px-2 space-y-2">
                    <div v-for="question in questions" :key="question.id">
                        <div class="block w-full cursor-pointer" @click="selectQuestion(question)">
                            <div class="font-bold">{{ question.título }}</div>
                            <div class="">
                                {{ question.corpo_texto }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Shell>
</template>

<script>
import Shell from './Shell.vue'
import { debounce } from '@Shared/Functions'

export default {
    props: ['transition'],
    components: { Shell },
    mounted() {
        this.searchDebounced = debounce(() => {
            this.$store.dispatch('searchForQuestions')
        }, 500)
    },
    computed: {
        questions() {
            let result = this.$store.state.questionsFoundFromKnowledgeDatabaseSearch
            if (result && result.data) return result.data
            if (Array.isArray(result)) return result
            return []
        },

        search: {
            get() {
                return this.$store.state.search
            },

            set(value) {
                this.$store.commit('updateSearch', value)
            },
        },
    },
    watch: {
        search(value) {
            if (!value) return
            this.searchDebounced()
        },
    },
    methods: {
        voltar() {
            if (this.$store.state.selectedQuestionId) {
                this.$store.commit('selectQuestion', null)
            } else {
                this.$store.dispatch('transiçãoParaEsquerda', 'home')
            }
        },

        selectQuestion(question) {
            this.$store.commit('selectQuestion', question.id)
            this.$store.dispatch('transiçãoParaDireita', 'read_question')
        },
    },
}
</script>